<template>
  <div>
    <LayoutHeaderWorks
      activeNav="比赛评选"
      :topColor="topColor"
      btnType="detail"
      :height="380"
    />
    <div class="container">
      <section class="nav">
        <ul>
          <li
            :class="nav_item.name === worksClass.name ? 'activeNav' : ''"
            v-for="(nav_item, nav_index) in navList"
            :key="nav_index"
            @click="changeActive(nav_item)"
          >
            {{ nav_item.name }}
          </li>
        </ul>
      </section>

      <section class="top">
        <span>全部作品：{{ total }}</span>
        <span @click="toWorks">全部作品&gt;&gt;</span>
      </section>

      <LayoutNoData v-if="worksList.length == 0" />

      <section v-if="worksList[0] && page == 1" class="work_first">
        <div class="left">
          <img :src="worksList[0].img_full" alt=""  style="object-fit:cover;" />
          <div class="text">
            <h1>
              {{ worksList[0].title }} <span v-if="worksList[0].is_vote==1">{{ worksList[0].ticket }}票</span>
            </h1>
            <h2>{{ worksList[0].author }}</h2>
            <p>
              {{ worksList[0].synopsis }}
            </p>
          </div>
        </div>
        <div class="right">
          <div
            v-if="
			  worksList[0].is_vote==1 &&
              userInfo.expert_info.status_apply == undefined ||
              userInfo.expert_info.status_apply == 0
            "
            @click="sendTicket(worksList[0])"
          >
            为ta投票
          </div>
          <div>分享</div>
        </div>
        <i class="topThreeTitle first"></i>
      </section>

      <section v-if="page == 1" class="work_middle">
        <div v-if="worksList[1]" class="work_second">
          <div class="left">
            <img :src="worksList[1].img_full" alt=""  style="object-fit:cover;" />
          </div>
          <div class="right">
            <div class="text">
              <h1>
                {{ worksList[1].title }}
                <span v-if="worksList[1].is_vote==1">{{ worksList[1].ticket }}票</span>
              </h1>
              <h2>{{ worksList[1].author }}</h2>
            </div>
            <div class="btns">
              <div
                v-if="
				  worksList[1].is_vote==1 &&
                  userInfo.expert_info.status_apply == undefined ||
                  userInfo.expert_info.status_apply == 0
                "
				 @click="sendTicket(worksList[1])"
              >
                为ta投票
              </div>
              <div>分享</div>
            </div>
          </div>
          <i class="topThreeTitle second"></i>
        </div>
        <div v-if="worksList[2]" class="work_third">
          <div class="left">
            <img :src="worksList[2].img_full" alt=""  style="object-fit:cover;"/>
          </div>
          <div class="right">
            <div class="text">
              <h1>
                {{ worksList[2].title }}
                <span v-if="worksList[2].is_vote==1">{{ worksList[1].ticket }}票</span>
              </h1>
              <h2>{{ worksList[2].author }}</h2>
            </div>
            <div class="btns">
              <div
                v-if="
				  worksList[2].is_vote==1 &&
                  userInfo.expert_info.status_apply == undefined ||
                  userInfo.expert_info.status_apply == 0
                "
				 @click="sendTicket(worksList[2])"
              >
                为ta投票
              </div>
              <div>分享</div>
            </div>
          </div>
          <i class="topThreeTitle third"></i>
        </div>
      </section>

      <section class="work_bottom">
        <ul>
          <li
            v-for="(work_item, work_index) in worksList_bottom"
            :key="work_index"
          >
            <div class="left">
              <i :class="4 + work_index < 10 ? 'isTopNine' : 'notTopNine'">{{
                4 + work_index + 9*(page-1)
              }}</i>
              <img :src="work_item.img_full" alt="" style="object-fit:cover;"/>
              <div class="text">
                <h1>
                  {{ work_item.title }} <span v-if="work_item.is_vote==1">{{ work_item.ticket }}票</span>
                </h1>
                <h2>{{ work_item.author }}</h2>
              </div>
            </div>
            <div class="right">
              <div
                v-if="
				  work_item.is_vote==1&&
                  userInfo.expert_info.status_apply == undefined ||
                  userInfo.expert_info.status_apply == 0
                "
				 @click="sendTicket(work_item)"
              >
                为ta投票
              </div>
              <div>分享</div>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <LayoutPaging
      :total="total"
      @handleChange="changePage"
      style="margin-bottom: 70px"
    />
    <LayoutFooter />
  </div>
</template>

<script>
import SystemServices from "../../xx-vue/services/system";
import { createNamespacedHelpers } from "vuex";
import Storage from "../../xx-vue/utils/storage";
const { mapState, mapMutations, mapActions } = createNamespacedHelpers(
  "WorkTop"
);
export default {
  data() {
    return {
      topColor: "",
      navList: [],
      userInfo: {
        expert_info: {
          id: undefined,
        },
        page: 1,
      },
    };
  },
  computed: {
    ...mapState([
      "worksList",
      "worksList_bottom",
      "worksClass",
      "page",
      "total",
    ]),
  },
  mounted() {
    this.initScroll();
    this.initData();
    const userInfo = Storage.getStorage("info");
    if (userInfo) {
      this.userInfo = userInfo;
      console.log(this.userInfo);
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  watch: {
    worksClass() {
      this.getWorksList({ project_id: ~~this.$route.query.project_id });
    },
    page() {
      this.getWorksList({ project_id: ~~this.$route.query.project_id });
    },
  },
  methods: {
    ...mapActions(["getWorksList", "send_Ticket"]),
    ...mapMutations(["changePage", "changeClass"]),
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.changeClass(val);
      this.$router.push(
        `/match/match_top?project_id=${this.$route.query.project_id}&group_id=${val.id}`
      );
    },
    //跳转作品
    toWorks() {
		var project_id = this.$route.query.project_id;
        this.$router.push("/match/match_works?project_id="+project_id+"&group_id="+~~this.$route.query.group_id);
    },
    //初始化数据
    async initData() {
      const result = await SystemServices.getGroupAsync({
        project_id: ~~this.$route.query.project_id,
      });
      this.navList = result.data.list.map((v) => {
        return { name: v.name, id: v.id };
      });
      const active = this.navList.filter(
        (v) => v.id === ~~this.$route.query.group_id
      );
      this.changeClass(active[0]);
      console.log(this.worksClass);
    },
    //投票
    async sendTicket(item) {
      console.log(item);
      const result = await this.send_Ticket({
        project_id: ~~this.$route.query.project_id,
        item: item,
      });
      if (result) {
        this.$message.success("投票成功！");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  .nav {
    box-shadow: 0px 4px 8px #c7c7c7;
    position: relative;
    ul {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      li {
        margin-right: 50px;
        font-size: 18px;
        color: #333333;
        cursor: pointer;
        padding: 20px;
      }

      .activeNav {
        color: #f2252f;
        font-weight: bold;
        border-bottom: 2px solid #e24141;
      }
    }
  }

  .top {
    width: 1200px;
    margin: 0 auto;
    padding: 42px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    & > :nth-child(1) {
      color: #989898;
      font-size: 18px;
    }
    & > :nth-child(2) {
      color: #f2252f;
      cursor: pointer;
      font-weight: bold;
    }
  }

  .work_first {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 42px 0;
    display: flex;
    justify-content: space-between;
    background: url("../../assets/images/match/bs-List1-bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 10px 62px 10px 10px;
    color: #fffefe;
    // margin-bottom: 30px;
    position: relative;
    .left {
      display: flex;
      min-width: 70%;
      & > img {
        width: 480px;
        height: 240px;
        border-radius: 6px;
        margin-right: 20px;
      }
      .text {
        margin-top: 52px;
        h1 {
          font-size: 18px;
          margin-bottom: 14px;
          span {
            color: #ff9595;
            font-size: 16px;
            margin-left: 6px;
          }
        }

        h2 {
          font-size: 18px;
          font-weight: normal;
          margin-bottom: 32px;
        }

        p {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .right {
      font-weight: bold;
    }

    .right {
      div {
        background: url("../../assets/images/match/bs-list-but1.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        padding: 10px 16px;
        cursor: pointer;
      }

      & > :first-child {
        margin-top: 42px;
        margin-bottom: 42px;
      }
    }
    .first {
      background: url("../../assets/images/match/bs-list-tip1.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .topThreeTitle {
    width: 88px;
    height: 40px;
    position: absolute;
    left: 0;
    top: 20px;
  }

  .work_middle {
    width: 1200px;
    margin: 0 auto;
    padding: 42px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #dddddd;
    & > div {
      width: 48%;
    }
    .work_second {
      display: flex;
      justify-content: space-between;
      padding: 10px 32px 10px 10px;
      position: relative;
      background: url("../../assets/images/match/bs-List2-bg.png") no-repeat;
      background-size: 100% 100%;
      .left {
        margin-right: 20px;
        & > img {
          width: 320px;
          height: 160px;
          border-radius: 6px;
        }
      }

      .right {
        flex: 1;
        .text {
          color: #fffefe;
          h1 {
            font-size: 18px;
            margin-bottom: 14px;
            margin-top: 20px;
            span {
              color: #ffa495;
              font-size: 16px;
            }
          }

          h2 {
            font-size: 18px;
          }

          h2 {
            font-size: 18px;
            margin-bottom: 24px;
          }
        }

        .btns {
          display: flex;
          justify-content: space-between;
          div {
            width: 88px;
            padding: 10px 0;
            text-align: center;
            background: url("../../assets/images/match/bs-list-but2.png")
              no-repeat;
            background-size: 100% 100%;
            color: #fffefe;
            font-weight: bold;
            cursor: pointer;
          }
        }
      }
    }

    .work_third {
      display: flex;
      position: relative;
      justify-content: space-between;
      padding: 10px 32px 10px 10px;
      background: url("../../assets/images/match/bs-List3-bg.png") no-repeat;
      background-size: 100% 100%;
      .left {
        margin-right: 20px;
        & > img {
          width: 320px;
          height: 160px;
          border-radius: 6px;
        }
      }

      .right {
        flex: 1;
        .text {
          color: #fffefe;
          h1 {
            font-size: 18px;
            margin-bottom: 14px;
            margin-top: 20px;
            span {
              color: #ffba95;
              font-size: 16px;
            }
          }

          h2 {
            font-size: 18px;
          }

          h2 {
            font-size: 18px;
            margin-bottom: 24px;
          }
        }

        .btns {
          display: flex;
          justify-content: space-between;
          div {
            width: 88px;
            padding: 10px 0;
            text-align: center;
            background: url("../../assets/images/match/bs-list-but3.png")
              no-repeat;
            background-size: 100% 100%;
            color: #fffefe;
            font-weight: bold;
            cursor: pointer;
          }
        }
      }
    }

    .second {
      background: url("../../assets/images/match/bs-list-tip2.png") no-repeat;
      background-size: 100% 100%;
    }

    .third {
      background: url("../../assets/images/match/bs-list-tip3.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .work_bottom {
    width: 1200px;
    margin: 0 auto;
    padding: 42px 0;
    ul {
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 20px;
        .left {
          display: flex;
          align-items: center;
          .isTopNine {
            display: block;
            width: 36px;
            line-height: 36px;
            height: 48px;
            background: url("../../assets/images/match/bs-list-tip4.png");
            font-style: normal;
            font-size: 24px;
            color: #a32225;
            text-align: center;
            margin-right: 14px;
            font-weight: bold;
          }

          .notTopNine {
            display: block;
            width: 36px;
            line-height: 36px;
            height: 48px;
            font-style: normal;
            font-size: 24px;
            color: #a32225;
            text-align: center;
            margin-right: 14px;
            font-weight: bold;
          }

          img {
            width: 200px;
            height: 100px;
            border-radius: 6px;
            margin-right: 16px;
          }

          .text {
            margin-top: 20px;
            h1 {
              font-size: 18px;
              color: #333333;
              margin-bottom: 14px;
              span {
                color: #a32225;
                font-size: 16px;
              }
            }
            h2 {
              font-size: 18px;
              font-weight: normal;
              color: #333333;
            }
          }
        }

        .right {
          width: 18%;
          display: flex;
          justify-content: space-between;
          div {
            width: 88px;
            height: 36px;
            background: url("../../assets/images/match/bs-list-but4.png")
              no-repeat;
            background-size: 100% 100%;
            text-align: center;
            line-height: 36px;
            font-weight: bold;
            color: #a32225;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>